import { jsxs as c, jsx as l } from "react/jsx-runtime";
const o = (a) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.75 7.86a.854.854 0 0 0-.13.105l-1.03 1.03c.16.295.36.565.605.81.245.245.52.445.81.605L8.03 9.385c.04-.04.075-.085.11-.13-.325-.09-.63-.25-.885-.505a1.971 1.971 0 0 1-.505-.885V7.86ZM8.76 4.41l.825-.825a2.002 2.002 0 0 1 2.83 0 2.002 2.002 0 0 1 0 2.83l-.825.825a4.45 4.45 0 0 1 .21 1.91l1.67-1.675A3.48 3.48 0 0 0 14.495 5a3.48 3.48 0 0 0-1.025-2.475A3.48 3.48 0 0 0 10.995 1.5 3.48 3.48 0 0 0 8.52 2.525L6.845 4.2a4.615 4.615 0 0 1 1.915.21Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m11.59 7.235-.82.82a3.455 3.455 0 0 1-.39 2.32c.275-.155.53-.34.765-.575l.655-.655a4.59 4.59 0 0 0-.21-1.91ZM8.145 9.245c-.035.045-.065.09-.11.13L7.01 10.4c.33.18.685.3 1.05.365l.685-.685c.24-.24.4-.535.495-.85-.36.105-.735.11-1.095.01v.005Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m7.24 11.59-.825.825c-.755.755-2.075.755-2.83 0a2.002 2.002 0 0 1 0-2.83l.825-.825a4.45 4.45 0 0 1-.21-1.91L2.53 8.525A3.48 3.48 0 0 0 1.505 11a3.48 3.48 0 0 0 1.025 2.475A3.48 3.48 0 0 0 5.005 14.5a3.48 3.48 0 0 0 2.475-1.025L9.155 11.8a4.615 4.615 0 0 1-1.915-.21ZM9.25 8.14a.854.854 0 0 0 .13-.105l1.03-1.03a3.494 3.494 0 0 0-.605-.81 3.603 3.603 0 0 0-.81-.605L7.97 6.615c-.04.04-.075.085-.11.13.325.09.63.25.885.505.25.25.415.555.505.885v.005Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m4.41 8.765.82-.82a3.455 3.455 0 0 1 .39-2.32c-.275.155-.53.34-.765.575l-.655.655a4.59 4.59 0 0 0 .21 1.91ZM6.76 6.765a1.99 1.99 0 0 1 .565-.09c.18 0 .355.03.53.08.035-.045.065-.09.11-.13L8.99 5.6c-.33-.18-.685-.3-1.05-.365l-.685.685c-.24.24-.4.535-.495.85v-.005Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.23 7.945.685-.685c.245-.245.54-.4.85-.495.095-.315.255-.61.495-.85l.685-.685a3.51 3.51 0 0 0-2.325.395 3.469 3.469 0 0 0-.39 2.32ZM10.77 8.055l-.685.685c-.245.245-.54.4-.85.495-.095.315-.255.61-.495.85l-.685.685a3.47 3.47 0 0 0 2.325-.395 3.469 3.469 0 0 0 .39-2.32Z"
        }
      )
    ]
  }
);
export {
  o as Link
};
